import React, { useEffect, useState } from "react";
import classes from "./SubscribePage.module.css";
import { useLocation, useSearchParams } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';

const packs = [
    {
        id: "daily",
        label: "Daily subscription price point",
        price: "0.5 GHS / Day",
        colorClass: "dailyCard",
    },
    //   {
    //     id: "weekly",
    //     label: "Weekly subscription price point",
    //     price: "1.5 GHS / Week",
    //     colorClass: "weeklyCard",
    //   },
    //   {
    //     id: "monthly",
    //     label: "Monthly subscription price point",
    //     price: "3 GHS / Month",
    //     colorClass: "monthlyCard",
    //   },
];

const SubscribePage = () => {
    const [selectedPack, setSelectedPack] = useState("daily");

    const [extId, setExtId] = useState(null);
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        if (searchParams.get("ext_id")) {
            setExtId(searchParams.get("ext_id"));
        } else {
            setSearchParams({ ext_id: uuidv4() });
        }
    }, [searchParams]);

    const handleSubscribe = async () => {
        try {
            window.location.href = `http://gh-telecel-tcg.telenity.com/cg-he/92a5e72e-60c0-46b7-a11d-985a0e213bc2/?redirectUrl=https://gh-telecel.aagriculturezone.com&transactionId=${extId}`
        } catch (error) {
            console.log(error, 'error--');
        }
    }

    return (
        <div className={classes.container}>
            <div className={classes.wrapper}>
                <div className={classes.topSection}>
                    <h1 className={classes.title}>Agriczone</h1>
                    <p className={classes.subtitle}>
                        Choose your agriculture learning subscription pack
                    </p>
                </div>

                <div className={classes.packSection}>
                    <div className={classes.selectPackHeading}>Select a Pack</div>

                    <div className={classes.packList}>
                        {packs.map((pack) => {
                            const isSelected = selectedPack === pack.id;

                            return (
                                <div
                                    key={pack.id}
                                    className={`${classes.packCard} ${classes[pack.colorClass]} ${isSelected ? classes.activeCard : ""
                                        }`}
                                    onClick={() => setSelectedPack(pack.id)}
                                >
                                    <div className={classes.packContent}>
                                        <div className={classes.smallTag}>{pack.label}</div>
                                        <div className={classes.priceText}>{pack.price}</div>
                                    </div>

                                    <div
                                        className={`${classes.radioCircle} ${isSelected ? classes.radioSelected : ""
                                            }`}
                                    >
                                        {isSelected && <span className={classes.checkMark}>✓</span>}
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    <button className={classes.subscribeBtn} onClick={handleSubscribe}>Subscribe Now</button>

                    <p className={classes.infoText}>
                        Agriczone provides useful agriculture videos and farming knowledge
                        including crop guidance, irrigation tips, pest control, and modern
                        farming practices.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default SubscribePage;